import { environmentVars } from 'constants/services';
import { FeatureFlag } from 'featureFlags';
import { getAppServices } from 'providers/app-services';
import { BroadcastPayload } from 'records/broadcast';

export interface Payload {
  registertype: string;
  filter: string;
  userid: string;
}

export const registerForEvents = async (
  payload: BroadcastPayload
): Promise<boolean> => {
  const { authService, featureFlagService } = getAppServices();
  const { accessToken } = authService.getCredentials();
  const useAlternateUrl = featureFlagService.hasFeature(
    FeatureFlag.UseAlternateURLs
  );
  const endpoint = useAlternateUrl
    ? environmentVars.API_GATEWAY_ENDPOINT_02
    : environmentVars.API_GATEWAY_ENDPOINT;
  const response = await fetch(`${endpoint}/register`, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),
  });

  return response.ok;
};
